import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { useConnect, useDisconnect, useAccount, useSwitchChain } from "wagmi";
import chainConfig from "../../../../Provider/chainConfig";

function MyVerticallyCenteredModal(props) {
  const { connectors, connect } = useConnect();
  const { isConnected, address } = useAccount();
  const { disconnect } = useDisconnect();

  const { chain } = useAccount();
  const { switchChain } = useSwitchChain();

  useEffect(() => {
    if (isConnected && chain && chain.id) {
      const targetChainId = chainConfig[11155111].id;

      if (chain.id !== targetChainId) {
        switchChain({ chainId: targetChainId });
      }
    }
  }, [chain, isConnected]);

  const handleConnect = (connector) => {
    connect({ connector });
    props.onHide(); // Hide the modal after connecting
  };

  //   const handleDisconnect = () => {
  //     disconnect();
  //     console.log("Wallet disconnected!");
  //   };

  return (
    <Modal
      className="wallet-modal"
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <img src="/images/close.png" onClick={props.onHide} alt="" />
      </Modal.Header>
      <Modal.Body className="px-5">
        <div className="wallet-main">
          <h4>Connect Your Wallet</h4>
          <p>
            Say goodbye to app fatigue. TRIBE combines AI-powered chat, short
            video sharing, seamless shopping, and secure payments into a single,
            intuitive app. Experience the future of digital interaction today.
          </p>

          {connectors.map((connector) => (
            <div
              className="desktop my-4"
              style={{ width: "100%" }}
              key={connector.uid}
              onClick={() => handleConnect(connector)}
            >
              <button className="header-button" style={{ width: "100%" }}>
                <div style={{ fontSize: "18px" }}>
                  {connector.name === "MetaMask" ? (
                    <img
                      style={{ width: "35px", marginRight: "10px" }}
                      src="/images/metamask-fox.svg"
                      alt=""
                    />
                  ) : (
                    <img
                      style={{ width: "35px", marginRight: "10px" }}
                      src="/images/walletconnect.png"
                      alt=""
                    />
                  )}
                  {connector.name}
                </div>
                <div className="txt">Connect</div>
              </button>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default function JoinModal() {
  const [modalShow, setModalShow] = useState(false);
  const { isConnected } = useAccount();

  return (
    <>
      {!isConnected ? (
        <Link to="" className="apply" onClick={() => setModalShow(true)}>
          <img src="/images/arrow.png" alt="" />
          Join The Pre Sale
        </Link>
      ) : (
        <Link to={"/buy"} className="apply">
          <img src="/images/arrow.png" alt="" />
          Join The Pre Sale
        </Link>
      )}

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}
